import React, { useEffect, useState } from "react";

import { useManzanitaPresetApi } from "../../../../common/api/orders-api/manzanita-preset/useManzanitaPresetApi";
import { ManzanitaPresetListingItem, mapToManzanitaPresetListingItem } from "../ManzanitaPresetListingItem";
import { ManzanitaPresetListingContext } from "./ManzanitaPresetListingContext";

export type ManzanitaPresetListingProviderProps = React.PropsWithChildren<unknown>;

export const ManzanitaPresetListingProvider: React.FC<ManzanitaPresetListingProviderProps> = (
    props: ManzanitaPresetListingProviderProps
) => {
    const { getManzanitaPresetsList } = useManzanitaPresetApi();

    const [items, setItems] = useState<ManzanitaPresetListingItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        getManzanitaPresetsList()
            .then((response) => {
                const manzanitaPresetItems = response.items.map(mapToManzanitaPresetListingItem);
                setItems(manzanitaPresetItems);
            })
            .finally(() => setIsLoading(false));
    }, []);

    const addItem = (item: ManzanitaPresetListingItem): void => {
        setItems((prevItems) => {
            return [item, ...prevItems];
        });
    };

    const editItem = (item: ManzanitaPresetListingItem): void => {
        setItems((prevItems) => {
            const presetToEdit = prevItems.find((preset) => preset.id === item.id);

            if (!presetToEdit) return prevItems;

            presetToEdit.name = item.name;
            presetToEdit.updatedDate = item.updatedDate;

            return [...prevItems];
        });
    };

    return (
        <ManzanitaPresetListingContext.Provider
            value={{
                items,
                isLoading,
                addItem,
                editItem
            }}
        >
            {props.children}
        </ManzanitaPresetListingContext.Provider>
    );
};
